// extracted by mini-css-extract-plugin
export var modal = "ProductConfiguration-module--modal--3xfXD";
export var modalBackground = "ProductConfiguration-module--modalBackground--17NMw";
export var modalBody = "ProductConfiguration-module--modalBody--2Ew5d";
export var closeButton = "ProductConfiguration-module--closeButton--3rAwg";
export var changeButton = "ProductConfiguration-module--changeButton--1iRdn";
export var icon = "ProductConfiguration-module--icon--3te0X";
export var spinAround = "ProductConfiguration-module--spinAround--1kcvL";